/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterMolecule = new PostFilter(
  [['inchis', PostFilterComparison.contains]],
  'metadatas.molecule',
);

export const PostFilterExperimentWorkflowMolecule = new PostFilter(
  [['inchis', PostFilterComparison.contains]],
  'experiments.molecules',
);
